
import './App.scss';
import './assets/css/base.css'
import { RecoilRoot, atom, selectorFamily, useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { getQueryItem, isMobile } from './utils/util'
import { DesktopRoutes, MobileRoutes } from './routes';
import { ActivityInfoModel } from './models/typing';


export const activityId = atom<string>({
  key: 'activityId',
  default: getQueryItem('aid') || '17'
})

export const activityInfoState = atom<ActivityInfoModel>({
  key: 'activityInfo',
  default: {
    remark: '',
    questionnaire_list: [],
    uid: '',
    client_ip: null,
  }
})



function Page() {

  return (
    <>
      {
        isMobile() ? <MobileRoutes /> : <DesktopRoutes />
      }
    </>
  )

}

function App() {
  return (
    <RecoilRoot>
      <Page />
    </RecoilRoot>
  );
}


export default App;


